<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 id="toc-title">Emergence - Book One of the Alicorn Quest</h1>
<ol class="toc"><li id="toc-li-1"><a href="#/text/ch001">About the Author</a></li>
<li id="toc-li-2"><a href="#/text/ch002">Dedication</a></li>
<li id="toc-li-3"><a href="#/text/ch003">Copyright Information ©</a></li>
<li id="toc-li-4"><a href="#/text/ch004">Acknowledgment</a></li>
<li id="toc-li-5"><a href="#/text/ch005">Introduction</a></li>
<li id="toc-li-6"><a href="#/text/ch006">Part 1</a><ol class="toc"><li id="toc-li-7"><a href="#/text/Section0001#chapter-1-mamallapuram">Chapter 1: <span>Mamallapuram</span></a></li>
<li id="toc-li-8"><a href="#/text/Section0024#chapter-2-the-bangle-and-star">Chapter 2: The Bangle and Star</a></li>
<li id="toc-li-9"><a href="#/text/Section0002#chapter-3-disaster">Chapter 3: Disaster</a></li>
<li id="toc-li-10"><span href="#/text/Section0003#chapter-4-lost-temples" title="Link target outside of Sample">Chapter 4: Lost Temples</span></li>
<li id="toc-li-11"><span href="#/text/Section0004#afterword" title="Link target outside of Sample">Afterword</span></li>
</ol></li>
<li id="toc-li-12"><span href="#/text/ch007" title="Link target outside of Sample">Part 2</span><ol class="toc"><li id="toc-li-13"><span href="#/text/Section0005#chapter-5-madras" title="Link target outside of Sample">Chapter 5: Madras</span></li>
<li id="toc-li-14"><span href="#/text/Section0006#chapter-6-evil-anticipation" title="Link target outside of Sample">Chapter 6: Evil Anticipation</span></li>
<li id="toc-li-15"><span href="#/text/Section0007#chapter-7-diwali" title="Link target outside of Sample">Chapter 7: Diwali</span></li>
<li id="toc-li-16"><span href="#/text/Section0008#chapter-8-the-merchant-ship" title="Link target outside of Sample">Chapter 8: The Merchant Ship</span></li>
<li id="toc-li-17"><span href="#/text/Section0009#chapter-9-agilan" title="Link target outside of Sample">Chapter 9: Agilan</span></li>
<li id="toc-li-18"><span href="#/text/Section0010#chapter-10-it-is-written" title="Link target outside of Sample">Chapter 10: It is Written</span></li>
<li id="toc-li-19"><span href="#/text/Section0011#chapter-11-the-path" title="Link target outside of Sample">Chapter 11: The Path</span></li>
<li id="toc-li-20"><span href="#/text/Section0012#chapter-12-custom-house" title="Link target outside of Sample">Chapter 12: Custom House</span></li>
<li id="toc-li-21"><span href="#/text/Section0013#chapter-13-uncertainty" title="Link target outside of Sample">Chapter 13: Uncertainty</span></li>
<li id="toc-li-22"><span href="#/text/Section0014#chapter-14-the-tuscany" title="Link target outside of Sample">Chapter 14: The Tuscany</span></li>
<li id="toc-li-23"><span href="#/text/Section0015#chapter-15-last-day" title="Link target outside of Sample">Chapter 15: Last Day</span></li>
<li id="toc-li-24"><span href="#/text/Section0016#chapter-16-leaving-home" title="Link target outside of Sample">Chapter 16: Leaving Home</span></li>
<li id="toc-li-25"><span href="#/text/Section0017#chapter-17-setting-sail" title="Link target outside of Sample">Chapter 17: Setting Sail</span></li>
</ol></li>
<li id="toc-li-26"><span href="#/text/ch008" title="Link target outside of Sample">Part 3</span><ol class="toc"><li id="toc-li-27"><span href="#/text/Section0018#chapter-18-eastern-oregon" title="Link target outside of Sample">Chapter 18: Eastern Oregon</span></li>
<li id="toc-li-28"><span href="#/text/Section0019#chapter-19-fire-creek" title="Link target outside of Sample">Chapter 19: Fire Creek</span></li>
<li id="toc-li-29"><span href="#/text/Section0020#chapter-20-annie-and-samuel" title="Link target outside of Sample">Chapter 20: Annie and Samuel</span></li>
<li id="toc-li-30"><span href="#/text/Section0021#chapter-21-new-friendship" title="Link target outside of Sample">Chapter 21: New Friendship</span></li>
<li id="toc-li-31"><span href="#/text/Section0022#chapter-22-princess-kooskooskia" title="Link target outside of Sample">Chapter 22: Princess Kooskooskia</span></li>
<li id="toc-li-32"><span href="#/text/Section0023#chapter-23-caring" title="Link target outside of Sample">Chapter 23: Caring</span></li>
</ol></li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?5ac74e94